import apiCLient from '@shared/apiClient'

const SERVICE_PATH = 'user-content/config'

export const getApiClient = () => apiCLient.partneringOnePlus(SERVICE_PATH)
